import React from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import moment from "moment";
import Image from "react-bootstrap/Image";
// import { PopupActionButton } from "../../buttonReusableComponent/ButtonReusableComponent";
import CallingButtonPopup from "../../allPopupReusable/CallingButtonPopup";
import SendSmsButton from "../../allPopupReusable/SendSmsButton";
import NotificationButton from "../../allPopupReusable/NotificationButton";
import ViewButtonPopup from "../../allPopupReusable/ViewButtonPopup";
import { PopupIconButtonReusable } from "../../allPopupReusable/allPopupReusableIconButton/PopupIconButtonReusable";
import EditReservation from "../../allPopupReusable/editDinerAndEditReservaion/EditReservation";
import { NewCountDown } from "../../allPopupReusable/tableNumberPopup/NewCountDown";
import LocationReusable from "../../allPopupReusable/locationReusablePopup/LocationReusable";
import DeletePopup from "../../allPopupReusable/smallPopup/DeletePopup";
import EditWaitTime from "../../allPopupReusable/tableNumberPopup/EditWaitTime";

export const ReservationDashboardMobileBody = ({
  indexKey,
  dinnerId,
  dinnerOrderType,
  dinnerName,
  totalCount,
  totalAdult,
  totalKids,
  totalHighchair,
  totalHandicapped,
  displayLocation,
  date,
  time,
  displayButton,
  displayButtonTwo,
  seatingPreference,
  displayCall,
  displaySms,
  displayNotification,
  displayChat,
  displayViewDiner,
  displayEditDiner,
  tableNo,
  roomNo,
  specialOcassion,
  status,
  sendDataDinerProps,
}) => {
  // var text = "blahalhahkanhklanlkanhlanlanhak";
  // var count = 15;
  // var result = text.slice(0, count) + (text.length > count ? "..." : "");
  const currentTimeOne = new Date();
  const updatedTime = new Date(sendDataDinerProps.updatedAt);
  var endTime = moment(currentTimeOne).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(sendDataDinerProps.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  const currentTime = new Date().getTime();
  const updatedTimeNew = updatedTime.getTime();
  const waitTime = sendDataDinerProps.wait_time * 60 * 1000;
  let updateWaitTime = updatedTimeNew + waitTime;
  let diff = updateWaitTime - currentTime;

  return (
    <React.Fragment>
      <div className="seating-dashboard-mobile-body-time">
        <h4>{moment(sendDataDinerProps.reservationTime).format("hh:mm a")}</h4>
      </div>
      <Accordion>
        <Card className="main-reusable-accordion">
          <Accordion.Toggle as={Card.Header} eventKey={indexKey}>
            <div className="row">
              <div className="col-5 card-header-left">
                <p className="order-id">{dinnerId}</p>
                <div className="d-flex align-items-center">
                  <Image
                    src={require("../../../../assets/images/ActionImages/online-booking.svg")}
                    alt="Order Type"
                    title="Order Type"
                    className="order-type-Image"
                  />
                  <p className="order-diner-name-green">{dinnerName}</p>
                </div>
              </div>
              <div className="col-3 card-header-middle">
                <div className="row">
                  <div className="total-pax">
                    <p className="total-pax-value">{totalCount}</p>
                    <p className="total-pax-light-text">PAX</p>
                  </div>
                  <div className="total-adult-kids">
                    <div className="display-align">
                      <Image
                        src={require("../../../../assets/images/ActionImages/employees.png")}
                        alt="Adult"
                        title="Adult"
                        className="pax-type-Image"
                      />
                      <p className="total-count">{totalAdult}</p>
                    </div>
                    <div className="display-align">
                      <Image
                        src={require("../../../../assets/images/ActionImages/children.png")}
                        alt="Kids"
                        title="Kids"
                        className="pax-type-Image"
                      />
                      <p className="total-count">{totalKids}</p>
                    </div>
                  </div>
                  <div className="total-highchair-handicapp">
                    <div className="display-align">
                      <Image
                        src={require("../../../../assets/images/ActionImages/highchair.png")}
                        alt="Highchair"
                        title="Highchair"
                        className="pax-type-Image-highchair"
                      />
                      <p className="total-count">{totalHighchair}</p>
                    </div>
                    <div className="display-align">
                      <Image
                        src={require("../../../../assets/images/ActionImages/wheelchair.png")}
                        alt="Handicapped"
                        title="Handicapped"
                        className="pax-type-Image-handicapped"
                      />
                      <p className="total-count">{totalHandicapped}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-4 card-header-right">
                <div>
                  <p className="reservation-wait-time-headtext">
                    {moment(sendDataDinerProps.reservationTime).format(
                      "hh:mm A"
                    )}
                  </p>
                  <div>
                    <p className="wait-time-bold-red">
                      {/* {time_convert(minutes)} */}
                      {/* {sendDataDinerProps.waitNew === "" ||
                      sendDataDinerProps.waitNew === null ||
                      sendDataDinerProps.waitNew === undefined ? (
                        "00:00:00"
                      ) : ( */}
                      <NewCountDown waitNew={diff} />
                      {/* )} */}
                    </p>
                    <p className="wait-time-boldtwo">HH:MM:SS</p>
                  </div>
                </div>
                <div className="popup-image">
                  {/* <Image
                    src={require("../../../../assets/images/ActionImages/newEdit.png")}
                    alt="Handicapped"
                    title="Handicapped"
                    className="wait-time-edit"
                  /> */}
                  <EditWaitTime allDataProps={sendDataDinerProps._id} />
                </div>
              </div>
            </div>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey={indexKey}>
            <Card.Body>
              {/******* Section One *********/}
              <div className="row">
                <div className="col-5 sectionone-left">
                  <p className="top-heading-gray">Total Wait time</p>
                  <div className="time-section">
                    <p className="top-heading-black">
                      {time_convert(minutes)}
                      {/* 00 <span className="small-hh-mm-text">HH</span> : 00{" "}
                      <span className="small-hh-mm-text">mins</span> */}
                    </p>
                  </div>
                </div>
                <div className="col-3 sectionone-middle">
                  <p className="top-heading-gray">User</p>
                  <div className="box-border">
                    <LocationReusable dataSend={sendDataDinerProps} />
                  </div>
                </div>
                <div className="col-4 sectionone-right">
                  <p className="top-heading-gray">Date</p>
                  <p className="top-heading-black">{date}</p>
                  <p className="top-heading-black">{time}</p>
                </div>
              </div>

              {/******* Section Two *********/}
              <div className="sectiontwo">
                <div className="sectiontwo-left">
                  {sendDataDinerProps.diner_status === "SEATED" ? (
                    <div>
                      <DeletePopup
                        buttonDisplay="smallCancelButton"
                        displayPopup="seatingUnseated"
                        buttonText="Unseat"
                        bigText="Are you sure to Unseat ?"
                        dataSend={sendDataDinerProps}
                      />
                    </div>
                  ) : (
                    <div>
                      <DeletePopup
                        buttonDisplay="smallCancelButton"
                        displayPopup="resonFforCancellation"
                        buttonText="Cancel"
                        bigText="Are you sure to Cancel ?"
                        dataSend={sendDataDinerProps._id}
                      />
                    </div>
                  )}
                </div>
                <div className="sectiontwo-middle">
                  <p className="top-heading-gray">Seating Preferences</p>
                  <p className="top-heading-black">{seatingPreference}</p>
                </div>
                <div className="sectionthree-right">
                  {sendDataDinerProps.diner_status === "SEATED" ? (
                    <div>
                      <DeletePopup
                        buttonDisplay="smallSaveButton"
                        displayPopup="seatingCompleted"
                        buttonText="Complete"
                        bigText="Are you sure to Completed ?"
                        dataSend={sendDataDinerProps}
                      />
                    </div>
                  ) : (
                    <div>
                      <DeletePopup
                        buttonDisplay="smallSaveButton"
                        displayPopup="SeatedButton"
                        buttonText="Seat"
                        bigText="Are you sure to Seated ?"
                        dataSend={sendDataDinerProps._id}
                      />
                    </div>
                  )}
                </div>
              </div>

              {/******* Section Three *********/}
              <div className="col-12 sectionthree">
                {displayCall === true ? (
                  <CallingButtonPopup buttonClass="smallButton" />
                ) : null}
                {displaySms === true ? (
                  <SendSmsButton
                    buttonClass="smallButton"
                    dataSend={sendDataDinerProps}
                  />
                ) : null}
                {displayNotification === true ? (
                  <NotificationButton
                    buttonClass="smallButton"
                    dataSend={sendDataDinerProps}
                  />
                ) : null}
                {displayChat === true ? (
                  <PopupIconButtonReusable
                    buttonClass={"smallButton"}
                    titleText="Send Sms Button"
                    image={require("../../../../assets/images/ActionImages/chat.png")}
                    // onClick={this.onOpenModal}
                  />
                ) : null}
                {displayViewDiner === true ? (
                  <ViewButtonPopup
                    buttonClass="smallButton"
                    dataSend={sendDataDinerProps}
                  />
                ) : null}
                {displayEditDiner === true ? (
                  <EditReservation
                    buttonClass="smallButton"
                    bigText="Edit Reservation"
                    dataSend={sendDataDinerProps}
                  />
                ) : null}
              </div>

              {/******* Section Four *********/}
              <div className="col-12 sectionfour">
                <div className="sectionfour-left">
                  <p className="top-heading-gray">Table / Room No.</p>
                  <p className="small-text-medium">Table No. : {tableNo}</p>
                  <p className="small-text-medium">Room No. : {roomNo}</p>
                </div>
                <div className="sectionfour-middle">
                  <p className="top-heading-gray">Special Occasion</p>
                  <p className="small-text-regular">{specialOcassion}</p>
                </div>
                <div className="sectionfour-right">
                  <p className="top-heading-gray">Status</p>
                  <p className="small-text-bold">{status}</p>
                </div>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </React.Fragment>
  );
};

//02-06-2020
